import { Injectable } from '@angular/core';
import { AxisInputNumberPipe } from 'axis-components';
import { Utils } from 'axis-ui-generator';
import { CHECKBOXBAGGAGEITEMS, CHECKBOXHEADINGLITETRAVEL_GB, CHECKBOXLITEBAG, CHECKBOXLITEPERSONAL_GB } from 'src/app/features/fnol/config/fnol-constants';
import { DataStoreService } from 'src/app/features/fnol/services/data-store.service';
import { FnolService } from 'src/app/features/fnol/services/fnol.service';
import { ClaimtypeAbstractService } from './claimtype-abstract.service';
@Injectable({
  providedIn: 'root'
})
export class ClaimTypeGBService extends ClaimtypeAbstractService {

  momentDateFormat = 'DD-MM-YYYY';
  personalAccident = [];
  permanantdiablity;
  leavebenifit;
  otherClaimShow;
  accidentalDeatBoolean;
  foundmedical;
  policyDetails;
  phoneCodeList;
  insuredDetails = null;
  step2 = 'fnol-claimtype-details';
  step1 = 'fnol-claimant-info';
  country;
  hsotDrInfo = [];
  data;
  uiStructure: any;
  uiData: any;
  constructor(
    public dataStoreService: DataStoreService, public axisPipe: AxisInputNumberPipe,
    private fnolService: FnolService,
  ) {
    super();
  }

  getClaimTypeData() {
    if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Travel') {
      return this.getTravelDetails(this.step2);
    }
    else if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Other') {
      return this.getOtherDetails();
    }

    else if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Personal Accident') {
      return this.personalAccidentPayload();
    }
  }
  /**
   * Travel icon from step 2
   * @param step
   * @returns
   */
  getTravelDetails(step) {
    let travelDetailsInfo = [];
    travelDetailsInfo.push(
      {
        name: this.getData('claimBenefits', 'label', step)['label'] === 'Select Claim Type' ? 'What is the nature of your claim?' : '',
        value: this.dataStoreService.get(step).uiData['claimBenefits']
      });

    const travelInfo = ['heading', 'dateSymptom', 'dateVisit', 'startLocation', 'endLocation', 'diagnosisIllness', 'travelDestination', 'purposeOfTravel', 'contactAssistanceCompany', 'anyOtherInsurance'];

    const uiData = this.dataStoreService.get(step).uiData;
    travelInfo.forEach(fieldName => {

      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: 'Travel Details',
            value: 'heading'
          });
      } else {
        if (fieldName === 'diagnosisIllness' && fieldName.indexOf('diagnosisIllness') > -1) {
          travelDetailsInfo.push(
            {
              name: this.getData('diagnosisIllness', 'label', step)['label'],
              value: this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisIllness']?.name
            });
        } else if (fieldName === 'travelDestination') {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.countryOrder(this.getData(fieldName, '', step))
            });
        } else if (fieldName === 'contactAssistanceCompany') {
          if (uiData['contactAssistanceCompany'] === 'Yes' && uiData['contactAssistanceCompany'] !== null) {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step)
              },
              {
                name: this.getData('asstCompanyRef', 'label', step)['label'],
                value: this.getData('asstCompanyRef', '', step)
              }
            );
          } else {
            travelDetailsInfo.push(...this.captureData('contactAssistanceCompany'));
          }
        } else if (fieldName === 'anyOtherInsurance') {
          if (uiData['anyOtherInsurance'] === 'Yes' && uiData['anyOtherInsurance'] !== null) {
            const nonBagNoEMp = ['insuranceCompanyName', 'policyNumber', 'typeOfPolicy'];
            const otherInsurance = this.buildDetailsWithoutNull({ mainUIFieldName: 'addInsuranceDetailsMain', fieldNames: nonBagNoEMp, conditionalFieldName: 'anyOtherInsurance' });
            travelDetailsInfo.push(...this.captureData('anyOtherInsurance'), ...otherInsurance);
          } else {
            travelDetailsInfo.push(...this.captureData('anyOtherInsurance'));
          }
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step)
            }
          );
        }
      }
    });

    const travelBenefit = ['heading', 'chooseClaimTypeIllness'];
    travelBenefit.forEach(fieldName => {

      if (fieldName === 'heading') {
        travelDetailsInfo.push(
          {
            name: 'Travel Benefits',
            value: 'heading'
          });
      }
      else {
        const newArray = [];
        const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'];
        CHECKBOXHEADINGLITETRAVEL_GB.forEach(field => {
          chooseClaimType.forEach(element => {
            if (field.key === element.name) {
              const dataObj = Utils.getFieldFromStructure(this.uiStructure, element.name);
              const headingValue = dataObj.heading;
              newArray.push(headingValue);
            }
          });
        });
        travelDetailsInfo.push(
          {
            name: this.getData(fieldName, 'label', step)['label'],
            value: newArray.join(', ')
          }
        );
      }
    });

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingIncident') !== undefined) {
      const travelBenefitType = ['heading', 'injuredSick'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Medical Incident',
              value: 'heading'
            });
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.dataStoreService.get('fnol-claimtype-details').uiData['injuredSick'] === 'wasInjured' ? 'I was injured' : 'I was sick',
            }
          );
        }
      });

      if (uiData['injuredSick'] === 'wasInjured' && uiData['injuredSick'] !== null) {
        const insurance = ['claimDescribeWords', 'whenOccur', 'diagnosisInjured', 'medicalExpenseInjured', 'travelAccident', 'wereYouHospitalised', 'sufferedInjuryBefore'];
        insurance.forEach(fieldName => {
          if (fieldName === 'medicalExpenseInjured') {
            const medicalDetails = ['westernMedicine', 'dentalTreatment', 'otherExpenses', 'sum'];
            travelDetailsInfo.push(
              {
                name: 'Cost of Treatment',
                value: 'heading'
              }
            );
            
            medicalDetails.forEach(key => {
              travelDetailsInfo.push(
                {
                  name: key === 'westernMedicine' ? 'Medical Expense' : key === 'dentalTreatment' ? 'Dental Expense' : key === 'otherExpenses' ? 'Other Expenses' : key === 'sum' ? 'Total Claim Amount' : '',
                  // value: medicalExpenseInjured[key] && medicalExpenseInjured?.currency !== undefined ? medicalExpenseInjured?.currency?.label + ' ' + this.decimalConverter(medicalExpenseInjured[key], 'SG') : medicalExpenseInjured?.currency !== undefined ? medicalExpenseInjured?.currency?.label + ' 0.00' : ' 0.00'
                  value: this.dataStoreService.get(this.step2).uiData['medicalExpenseInjured'][key] ? ' ' + uiData['medicalExpenseInjured'].currency.label + ' ' + this.decimalConverter(this.dataStoreService.get(this.step2).uiData['medicalExpenseInjured'][key], 'SG') : ' ' + uiData['medicalExpenseInjured'].currency.label + ' 0.00'
                }
              );
            });
          } else if (fieldName === 'diagnosisInjured') {
            if (fieldName.indexOf('diagnosisInjured') > -1) {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisInjured', 'label', step)['label'],
                  value: this.getData('diagnosisInjured', '', step),
                });
            }
            if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisInjured'].id === '7') {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisOther', 'label', step)['label'],
                  value: this.getData('diagnosisOther', '', step),
                });
            }
          } else if (fieldName === 'travelAccident') {
            if (uiData['travelAccident'] === 'Yes' && uiData['travelAccident'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('travelAccident', 'label', step)['label'],
                  value: this.getData('travelAccident', '', step),
                },
                {
                  name: this.getData('claimDescribe', 'label', step)['label'],
                  value: this.getData('claimDescribe', '', step),
                },
                {
                  name: this.getData('nameCost', 'label', step)['label'],
                  value: this.checkCustom('nameCost', '', step, this.axisPipe),
                });
            } else {
              travelDetailsInfo.push({
                name: this.getData('travelAccident', 'label', step)['label'],
                value: this.getData('travelAccident', '', step),
              });
            }
          } else if (fieldName === 'wereYouHospitalised') {
            travelDetailsInfo.push(...this.captureData('wereYouHospitalised'));
            if (uiData['wereYouHospitalised'] === 'Yes') {
              travelDetailsInfo.push(...this.hospitalisationData('hospitalisedByInjuryMain'));
            }
          } else if (fieldName === 'sufferedInjuryBefore') {
            travelDetailsInfo.push(...this.captureData('sufferedInjuryBefore'));
            if (uiData['sufferedInjuryBefore'] === 'Yes') {
              travelDetailsInfo.push(
                {
                  name: this.getData('dateInjuryOccurred', 'label', step)['label'],
                  value: this.getData('dateInjuryOccurred', '', step),
                },
                {
                  name: this.getData('describePreviousInjury', 'label', step)['label'],
                  value: this.getData('describePreviousInjury', '', step),
                }
              );
            }
          } else {
            if (fieldName !== 'medicalExpenseInjured' && fieldName !== 'diagnosisInjured') {
              travelDetailsInfo.push({
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              });
            }
          }
        });

      } else if (uiData['injuredSick'] === 'wasSick' && uiData['injuredSick'] !== null) {
        const insurance = ['claimDescribeWordsSick', 'whenOccurSick', 'diagnosisSickInjuredSick', 'medicalExpenseSick', 'travelAccidentSick', 'hospitalisedBySick', 'sufferedSickBefore'];
        insurance.forEach(fieldName => {
          if (fieldName === 'medicalExpenseSick') {
            const medicalDetails = ['heading', 'westernMedicine', 'dentalTreatment', 'otherExpenses', 'sum'];
            medicalDetails.forEach(key => {
              if (key === 'heading') {
                travelDetailsInfo.push(
                  {
                    name: 'Cost of Treatment',
                    value: 'heading'
                  });
              } else {
                travelDetailsInfo.push(
                  {
                    name: key === 'westernMedicine' ? 'Medical Expense' : key === 'dentalTreatment' ? 'Dental Expense' : key === 'otherExpenses' ? 'Other Expenses' : key === 'sum' ? 'Total Claim Amount' : '',
                    value: this.dataStoreService.get(this.step2).uiData['medicalExpenseSick'][key] ? ' ' + uiData['medicalExpenseSick'].currency.label + ' ' + this.decimalConverter(this.dataStoreService.get(this.step2).uiData['medicalExpenseSick'][key], 'SG') : ' ' + uiData['medicalExpenseSick'].currency.label + ' 0.00'
                  }
                );
              }
            });
          } else if (fieldName === 'diagnosisSickInjuredSick') {
            if (fieldName.indexOf('diagnosisSickInjuredSick') > -1) {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisSickInjuredSick', 'label', step)['label'],
                  value: this.getData('diagnosisSickInjuredSick', '', step),
                });
            }
            if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickInjuredSick'].id === '13') {
              travelDetailsInfo.push(
                {
                  name: this.getData('diagnosisSickOtherSick', 'label', step)['label'],
                  value: this.getData('diagnosisSickOtherSick', '', step),
                });
            }
          } else if (fieldName === 'travelAccidentSick') {
            if (uiData['travelAccidentSick'] === 'Yes' && uiData['travelAccidentSick'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('travelAccidentSick', 'label', step)['label'],
                  value: this.getData('travelAccidentSick', '', step),
                },
                {
                  name: this.getData('claimDescribeSick', 'label', step)['label'],
                  value: this.getData('claimDescribeSick', '', step),
                },
                {
                  name: this.getData('nameCostSick', 'label', step)['label'],
                  value: this.checkCustom('nameCostSick', '', step, this.axisPipe),
                });
            } else {
              travelDetailsInfo.push({
                name: this.getData('travelAccidentSick', 'label', step)['label'],
                value: this.getData('travelAccidentSick', '', step),
              });
            }
          } else if (fieldName === 'hospitalisedBySick') {
            travelDetailsInfo.push(...this.captureData('hospitalisedBySick'));
            if (uiData['hospitalisedBySick'] === 'Yes') {
              travelDetailsInfo.push(...this.hospitalisationData('hospitalisedBySickMain'));
            }
          } else if (fieldName === 'sufferedSickBefore') {
            travelDetailsInfo.push(...this.captureData('sufferedSickBefore'));
            if (uiData['sufferedSickBefore'] === 'Yes') {
              travelDetailsInfo.push(
                {
                  name: this.getData('dateSickOccurred', 'label', step)['label'],
                  value: this.getData('dateSickOccurred', '', step),
                },
                {
                  name: this.getData('describePreviousSick', 'label', step)['label'],
                  value: this.getData('describePreviousSick', '', step),
                }
              );
            }
          } else {
            if (fieldName !== 'medicalExpenseSick' && fieldName !== 'diagnosisSickInjuredSick') {
              travelDetailsInfo.push({
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              });
            }
          }
        });
      }
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingDelayed') !== undefined) {
      const travelBenefitType = ['heading', 'originalFlightNumber', 'originalArriveDate', 'originalArriveTime', 'revisedFlightNumber', 'actualArriveDate', 'actualArriveTime', 'flightDelayedOccur', 'totalDelay', 'flightDelayed'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Delayed Flight',
              value: 'heading'
            });
        } else {
          if (fieldName === 'flightDelayed') {
            if (fieldName.indexOf('flightDelayed') > -1) {
              travelDetailsInfo.push(
                {
                  name: this.getData('flightDelayed', 'label', step)['label'],
                  value: this.getData('flightDelayed', '', step),
                });
            }
            if (this.dataStoreService.get('fnol-claimtype-details').uiData['flightDelayed'].id === '7') {
              travelDetailsInfo.push(
                {
                  name: this.getData('provideDetailsTravel', 'label', step)['label'],
                  value: this.getData('provideDetailsTravel', '', step),
                });
            }
          } else {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              }
            );
          }
        }
      });
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'cancelledOrCurtailed') !== undefined) {
      const travelBenefitTypeTripCancelled = ['heading', 'dateBookedTheTrip', 'dateOfCancellation', 'diagnosisSickTripSick', 'claimingForOther', 'flightExpense', 'flightRefund', 'accommodationExpense', 'accommodationRefund', 'otherExpenses', 'otherRefundedExpenses', 'pleaseProvideDetailsCancelled'];
      const travelBenefitTypeTripCurtailed = ['heading', 'dateBookedTheTripCurtail', 'dateOfCurtailment', 'tripCurtailed', 'tellusWhatHappened', 'flightExpenseCurtailed', 'flightRefundCurtailed', 'accommodationExpenseCurtailed', 'accommodationRefundCurtailed', 'otherExpensesCurtailed', 'otherRefundedExpensesCurtailed', 'pleaseProvideDetailsCurtailed'];

      travelDetailsInfo.push(
        {
          name: 'Cancelled or Curtailed Trip',
          value: 'heading'
        });

      travelDetailsInfo.push(
        {
          name: this.getData('cancelledOrCurtailedOptions', 'label', step)['label'],
          value: this.getData('cancelledOrCurtailedOptions', '', step),
        });

      if (uiData.cancelledOrCurtailedOptions === 'Cancelled') {

        travelBenefitTypeTripCancelled.forEach(fieldName => {

          if (fieldName === 'dateBookedTheTrip' || fieldName === 'dateOfCancellation') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.checkCustom(fieldName, '', step, this.axisPipe)
              }
            );
          }

          if (fieldName === 'diagnosisSickTripSick') {

            const cancelBasic = ['diagnosisSickTripSick', 'claimingForOther'];
            travelDetailsInfo = [...travelDetailsInfo, ...this.captureData(cancelBasic)];
            const diagnosisSickTripSick = this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosisSickTripSick'];

            if (diagnosisSickTripSick.id === '1' || diagnosisSickTripSick.id === '5' || diagnosisSickTripSick.id === '6') {
              const symptompsIllness = ['SymptomsFirstNoticed', 'accidentIllnessOccured'];
              travelDetailsInfo = [...travelDetailsInfo, ...this.captureData(symptompsIllness)];

              if (diagnosisSickTripSick.id !== '5') {
                travelDetailsInfo.push(
                  {
                    name: this.getData('travelCompanion', 'label', step)['label'],
                    value: this.getData('travelCompanion', '', step),
                  });

                const travelCompanion = this.dataStoreService.get('fnol-claimtype-details').uiData['travelCompanion'];

                if (travelCompanion.id === '4') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('otherBagsTripSick', 'label', step)['label'],
                      value: this.getData('otherBagsTripSick', '', step),
                    });
                }
              }

              const medicalProviderDetails = ['provideContactDetails', 'medicalProviderFullName'];
              travelDetailsInfo = [...travelDetailsInfo, ...this.captureData(medicalProviderDetails)];

              travelDetailsInfo.push(
                {
                  name: this.getData('medicalAddressAddressLookup', 'label', step)['label'],
                  value: this.dataStoreService.checkAutoComplete(this.getData('medicalAddressAddressLookup' + 'val', '', step) ? this.getData('medicalAddressAddressLookup' + 'val', '', step) : this.getData('medicalAddressAddressLookup', '', step).formatted_address ? this.getData('medicalAddressAddressLookup', '', step).formatted_address : this.getData('medicalAddressAddressLookup', '', step))
                }
              );
            }
          }
          if (fieldName === 'flightExpense' || fieldName === 'flightRefund' || fieldName === 'accommodationExpense' || fieldName === 'accommodationRefund' || fieldName === 'otherExpenses' || fieldName === 'otherRefundedExpenses') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.checkCustom(fieldName, '', step, this.axisPipe)
              }
            );
          }
          if (fieldName === 'pleaseProvideDetailsCancelled') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              }
            );
          }
        })
      } else if (uiData.cancelledOrCurtailedOptions === 'Curtailed') {

        travelBenefitTypeTripCurtailed.forEach(fieldName => {
          if (fieldName === 'dateBookedTheTripCurtail' || fieldName === 'dateOfCurtailment') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.checkCustom(fieldName, '', step, this.axisPipe)
              }
            );
          }
          if (fieldName === 'tripCurtailed') {
            const curtailedBasic = ['tripCurtailed', 'tellusWhatHappened'];
            travelDetailsInfo = [...travelDetailsInfo, ...this.captureData(curtailedBasic)];
            const tripCurtailed = this.dataStoreService.get('fnol-claimtype-details').uiData['tripCurtailed'];
            if (tripCurtailed.id === '7') {
              travelDetailsInfo.push(
                {
                  name: this.getData('notifyYouCurtailmet', 'label', step)['label'],
                  value: this.getData('notifyYouCurtailmet', '', step),
                }
              );
            }
            if (tripCurtailed.id === '1' || tripCurtailed.id === '5' || tripCurtailed.id === '6') {
              const symptompsIllness = ['SymptomsFirstNoticedCurtile', 'illnessOccuredCurtile', 'otherIncludingCurtailed'];
              travelDetailsInfo = [...travelDetailsInfo, ...this.captureData(symptompsIllness)];
              if (tripCurtailed.id !== '5') {
                travelDetailsInfo.push(
                  {
                    name: this.getData('travelCompanionCurtile', 'label', step)['label'],
                    value: this.getData('travelCompanionCurtile', '', step),
                  });
                const travelCompanionCurtile = this.dataStoreService.get('fnol-claimtype-details').uiData['travelCompanionCurtile'];
                if (travelCompanionCurtile.id === '4') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('otherProvideDetailsCurtailed', 'label', step)['label'],
                      value: this.getData('otherProvideDetailsCurtailed', '', step),
                    }
                  );
                }
              }
              const medicalProviderDetailsCurtailed = ['contactDetailsCurtailed', 'providerFullNameCurtailed'];
              travelDetailsInfo = [...travelDetailsInfo, ...this.captureData(medicalProviderDetailsCurtailed)];
              travelDetailsInfo.push(
                {
                  name: this.getData('medicaladdressCurtailed', 'label', step)['label'],
                  value: this.dataStoreService.checkAutoComplete(this.getData('medicaladdressCurtailed' + 'val', '', step) ? this.getData('medicaladdressCurtailed' + 'val', '', step) : this.getData('medicaladdressCurtailed', '', step).formatted_address ? this.getData('medicaladdressCurtailed', '', step).formatted_address : this.getData('medicaladdressCurtailed', '', step))
                }
              );
            }
          }

          if (fieldName === 'flightExpenseCurtailed' || fieldName === 'flightRefundCurtailed' || fieldName === 'accommodationExpenseCurtailed' || fieldName === 'accommodationRefundCurtailed' || fieldName === 'otherExpensesCurtailed' || fieldName === 'otherRefundedExpensesCurtailed') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.checkCustom(fieldName, '', step, this.axisPipe)
              }
            );
          }

          if (fieldName === 'pleaseProvideDetailsCurtailed') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              }
            );
          }
        });
      }
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingLost') !== undefined) {
      const travelBenefitType = ['heading', 'itemClaimType'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Baggage / Item Claim',
              value: 'heading'
            });
        } else {
          const newArray = [];
          const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'];
          CHECKBOXLITEBAG.forEach(field => {
            chooseClaimType.forEach(element => {
              if (field.key === element.name) {
                const headingValue = field.heading;
                newArray.push(headingValue);
              }
            });
          });
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: newArray.join(', ')
            }
          );
        }
      });

      const travelBagsDetails = ['travelBagsItems']
      travelBagsDetails.forEach(fieldName => {
        if (fieldName === 'travelBagsItems') {
          const newArray = [];
          const sortedArray = [];
          const baggageSelecteditems = this.dataStoreService.get('fnol-claimtype-details').uiData['travelBagsItems'];
          CHECKBOXBAGGAGEITEMS.forEach(field => {
            baggageSelecteditems.forEach(element => {
              if (field.key === element.name) {
                const headingValue = field.heading;
                newArray.push(headingValue);
                sortedArray.push(field);
              }
            });
          });
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: newArray.join(', ')
            });
          if (sortedArray.find(x => x.heading === 'Delayed') !== undefined) {
            const delayedDetails = ['heading', 'arrivalDate', 'arrivalTime', 'luggageBeenReturned'];
            delayedDetails.forEach(item => {
              if (item === 'heading') {
                travelDetailsInfo.push(
                  {
                    name: 'Baggage / Item Claim - Delayed',
                    value: 'heading'
                  }
                );
              }

              travelDetailsInfo.push(
                {
                  name: this.getData(item, 'label', step)['label'],
                  value: this.getData(item, '', step),
                }
              );
              if (item === 'luggageBeenReturned') {
                if (uiData[item] === 'Yes' && uiData[item] !== null) {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('returnedDate', 'label', step)['label'],
                      value: this.getData('returnedDate', '', step),
                    },
                    {
                      name: this.getData('timeReturned', 'label', step)['label'],
                      value: this.getData('timeReturned', '', step),
                    }
                  );
                }
              }
            });
          }

          if (sortedArray.find(x => x.heading === 'Damaged') !== undefined) {
            const delayedDetails = ['heading', 'bagsTripSick', 'damagedDate', 'provideDetails', 'heading1'];
            delayedDetails.forEach(item => {
              if (item === 'heading') {
                travelDetailsInfo.push(
                  {
                    name: 'Baggage / Item Claim - Damaged',
                    value: 'heading'
                  });
              }
              if (item === 'heading1') {
                travelDetailsInfo.push(
                  {
                    name: 'Bags and/or Items Details',
                    value: 'heading'
                  });
              } 
              if (item === 'bagsTripSick') {
                if (item.indexOf('bagsTripSick') > -1) {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('bagsTripSick', 'label', step)['label'],
                      value: this.getData('bagsTripSick', '', step),
                    });
                }
                if (this.dataStoreService.get('fnol-claimtype-details').uiData['bagsTripSick'].id === '3') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData('otherBagsTripSickDamaged', 'label', step)['label'],
                      value: this.getData('otherBagsTripSickDamaged', '', step),
                    });
                }
              } else {
                travelDetailsInfo.push(
                  {
                    name: this.getData(item, 'label', step)['label'],
                    value: this.getData(item, '', step),
                  }
                );
              }
            });

            if (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myBags' || ((this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myBags' && this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][1]?.name === 'myItems') || (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][1]?.name === 'myBags' && this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myItems'))) {
              const bagDamage = Utils.getFieldFromStructure(this.dataStoreService.get(step).uiStructure, 'addItemsMain').fields;
              bagDamage.forEach((card) => {
              card.fields.forEach((data, i) => {
                data?.fields?.forEach((item) => {
                  if (this.getData(item.name, '', this.step2) !== null) {
                    if (item.name.match('nameValue') || item.name.match('repairCost')) {
                      travelDetailsInfo.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.checkCustom(item.name, '', this.step2, this.axisPipe)
                      });
                    } else {
                      travelDetailsInfo.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.getData(item.name, '', this.step2)
                      });
                    }
                  }
                });
                });
              });
            } else if (this.dataStoreService.get('fnol-claimtype-details').uiData['itemClaimType'][0]?.name === 'myItems') {
              const bagDamage = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, 'addItemsMain').fields;
              bagDamage.forEach((card) => {
              card.fields.forEach((data, i) => {
                data?.fields?.forEach((item) => {
                  if (this.getData(item.name, '', this.step2) !== null && item.name.indexOf('repairCost') < 0) {
                    if (item.name.match('nameValue')) {
                      travelDetailsInfo.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.checkCustom(item.name, '', this.step2, this.axisPipe)
                      });
                    } else {
                      travelDetailsInfo.push({
                        'name': this.getData(item.name, 'label', this.step2)['label'],
                        'value': this.getData(item.name, '', this.step2)
                      });
                    }
                  }
                });
              });
              });
            }
          }

          if (sortedArray.find(x => x.heading === 'Lost or Stolen') !== undefined) {
            const lostStolenDetails = ['heading', 'stolenLost', 'timeOfLossTheft', 'stolenItem', 'stolenItemWas', 'stolenDate', 'itemswereStolen', 'bagsWereLastSeen', 'timeWereLastSeen', 'heading1'];
            lostStolenDetails.forEach(item => {
              if (item === 'heading') {
                travelDetailsInfo.push(
                  {
                    name: 'Baggage / Item Claim - Lost or Stolen',
                    value: 'heading'
                  });
              }
              if (item === 'heading1') {
                travelDetailsInfo.push(
                  {
                    name: 'Bags and/or Items Details',
                    value: 'heading',
                  });
              } else {
                travelDetailsInfo.push(
                  {
                    name: this.getData(item, 'label', step)['label'],
                    value: this.getData(item, '', step),
                  }
                );
              }
            });

            const lostStolen = Utils.getFieldFromStructure(this.dataStoreService.get(step).uiStructure, 'addStolenMain').fields;
            lostStolen.forEach((card) => {
            card.fields.forEach((data, i) => {
              const matches = data.name.match(/(\d+)/);
              const index1 = matches !== null ? matches[0] : '';
              const stolenDetails = ['bagItemStolen', 'nameStolenValue', 'yearStolenPurchased', 'heading'];
              stolenDetails.forEach((item) => {
                if (item === 'nameStolenValue') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item + index1, 'label', step)['label'],
                      value: this.checkCustom(item + index1, '', step, this.axisPipe)
                    }
                  );
                } else if (item === 'heading') {
                  travelDetailsInfo.push(
                    {
                      name: '',
                      value: 'heading'
                    }
                  );
                } else {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item + index1, 'label', step)['label'],
                      value: this.getData(item + index1, '', step)
                    }
                  );
                }
              });
            });
            });

            if (uiData['authorityReport'] === 'Yes' && uiData['authorityReport'] !== null) {
              travelDetailsInfo.push(
                {
                  name: this.getData('authorityReport', 'label', step)['label'],
                  value: this.checkCustom('authorityReport', '', step, this.axisPipe)
                },
                {
                  name: this.getData('authorityCopyReport', 'label', step)['label'],
                  value: this.checkCustom('authorityCopyReport', '', step, this.axisPipe)
                }
              );
            } else {
              travelDetailsInfo.push(
                {
                  name: this.getData('authorityReport', 'label', step)['label'],
                  value: this.checkCustom('authorityReport', '', step, this.axisPipe)
                }
              );
            }

            if (uiData['authorityReport'] === 'Yes' && uiData['authorityReport'] !== null) {
              const copyReport = ['nameAuthority', 'referenceNumber', 'phoneNumber', 'emailStolen', 'myAddressLookup'];
              copyReport.forEach(item => {
                if (item === 'myAddressLookup') {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item, 'label', step)['label'],
                      value: this.dataStoreService.checkAutoComplete(this.getData(item + 'val', '', step) ? this.getData(item + 'val', '', step) : this.getData(item, '', step).formatted_address ? this.getData(item, '', step).formatted_address : this.getData(item, '', step))
                    }
                  );
                } else if (item === 'phoneNumber' && uiData['phoneNumber'] !== null) {
                  travelDetailsInfo.push(
                    {
                      name: 'Phone Number',
                      value: this.phoneNumberValidation('phoneNumber')
                    });
                } else {
                  travelDetailsInfo.push(
                    {
                      name: this.getData(item, 'label', step)['label'],
                      value: this.checkCustom(item, '', step, this.axisPipe)
                    }
                  );
                }
              });
            }
          }
        }
      });
    }

    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingRentalVehicle') !== undefined) {

      const travelBenefitType = ['damageDetails', 'carRentalCompany', 'rentalAgreementDuration',
        'registrationNumber', 'subHeadingRentalVehicle', 'aggrementSigneeFirstName', 'subHeadingDriversRentalVehicle', 'driverInfo', 'thirdPartyDamage'];
      travelDetailsInfo.push(
        {
          name: 'Rental Vehicle Incident',
          value: 'heading'
        });

      travelDetailsInfo.push(
        {
          name: this.getData('damageWaiverRentalVehicle', 'label', step)['label'],
          value: this.getData('damageWaiverRentalVehicle', '', step),
        });

      travelBenefitType.forEach(fieldName => {
        if (uiData.damageWaiverRentalVehicle === 'Yes') {
          if (fieldName === 'damageDetails' || fieldName === 'carRentalCompany'
            || fieldName === 'registrationNumber'
          ) {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step),
              });
          }

          if (fieldName === 'aggrementSigneeFirstName') {
            travelDetailsInfo.push(
              {
                name: '',
                value: ''
              }
            );
            travelDetailsInfo.push(
              {
                name: 'Who signed the agreement with the rental company?',
                value: ''
              }
            );
            travelDetailsInfo.push(
              {
                name: this.getData('aggrementSigneeFirstName', 'label', step)['label'],
                value: this.getData('aggrementSigneeFirstName', '', step)
              }
            );
            travelDetailsInfo.push(
              {
                name: this.getData('aggrementSigneeLastName', 'label', step)['label'],
                value: this.getData('aggrementSigneeLastName', '', step)
              }
            );
          }

          if (fieldName === 'rentalAgreementDuration') {
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.getData(fieldName, '', step)
              }
            );
          }

          if (fieldName === 'driverInfo') {

            const res = this.getDriverInfo();
            travelDetailsInfo = [...travelDetailsInfo, ...res];
          }

          if (fieldName === 'thirdPartyDamage') {
            travelDetailsInfo.push(
              {
                name: '',
                value: ''
              }
            );
            travelDetailsInfo.push(
              {
                name: this.getData(fieldName, 'label', step)['label'],
                value: this.checkCustom(fieldName, '', step, this.axisPipe)
              });

            if (uiData.thirdPartyDamage === 'Yes') {
              const thirdPartyNames = ['thirdPartyFirstName', 'thirdPartyLastName']
              travelDetailsInfo = [...travelDetailsInfo, ...this.captureData(thirdPartyNames)]
              travelDetailsInfo.push(
                {
                  name: this.getData('thirdPartyAddress', 'label', step)['label'],
                  value: this.dataStoreService.checkAutoComplete(this.getData('thirdPartyAddress' + 'val', '', step) ? this.getData('thirdPartyAddress' + 'val', '', step) : this.getData('thirdPartyAddress', '', step).formatted_address ? this.getData('thirdPartyAddress', '', step).formatted_address : this.getData('thirdPartyAddress', '', step))
                }
              );
            }
          }
          travelDetailsInfo.push({
            name: this.getData('subHeadingRentalVehicle', 'label', step)['label'],
            value: this.getData('subHeadingRentalVehicle', '', step),
          });
        }
      });
    }
    if (this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimTypeIllness'].find(x => x.name === 'claimingOther') !== undefined) {
      const travelBenefitType = ['heading', 'claimingForOtherFor'];
      travelBenefitType.forEach(fieldName => {
        if (fieldName === 'heading') {
          travelDetailsInfo.push(
            {
              name: 'Other',
              value: 'heading'
            });
        } else {
          travelDetailsInfo.push(
            {
              name: this.getData(fieldName, 'label', step)['label'],
              value: this.getData(fieldName, '', step),
            }
          );
        }
      });
    }
    return travelDetailsInfo.filter(e => (e.name !== undefined));
  }

  getDriverInfo() {
    const driversInfo = Utils.getFieldFromStructure(this.uiStructure, 'addDriversRentalVehicleMain').fields;
    const medicalExpenseArray = [];
    medicalExpenseArray.push(
      {
        name: '',
        value: ''
      }
    );
    medicalExpenseArray.push(
      {
        name: 'Who were the named drivers on the agreement?',
        value: ''
      }
    );
    driversInfo.forEach((card) => {
      card.fields.forEach((data) => {
        data?.fields?.forEach((item) => {
          if (this.getData(item.name, '', this.step2) !== null) {
            medicalExpenseArray.push({
              'name': this.getData(item.name, 'label', this.step2)['label'],
              'value': this.getData(item.name, '', this.step2)
            });
          }
        });
      });
    });
    return medicalExpenseArray.filter(e => (e.name !== undefined && e.name !== null));
  }

  /**
   * Personal Accident icon
   * @returns
   */
  personalAccidentPayload() {
    let personalPayLoad = [];
    let hospitalDocInfoIsPresent = false;
    personalPayLoad = personalPayLoad.concat(this.getPersonalAccident());
    this.personalAccident.forEach(res => {
      if (res === 'Hospitalisation') {
        personalPayLoad = personalPayLoad.concat(this.hospitalisation());
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Fracture or Dislocation') {
        personalPayLoad = personalPayLoad.concat(this.fractureDislocation());
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Disability') {
        personalPayLoad = personalPayLoad.concat(this.PermanentDisablement('a'));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Accidental Death') {
        personalPayLoad = personalPayLoad.concat(this.accidentalDeath('a'));
        hospitalDocInfoIsPresent = true;
      }
      if (res === 'Other') {
        personalPayLoad = personalPayLoad.concat(this.otherDeath('a'));
      }
    });
    if (hospitalDocInfoIsPresent) {
      personalPayLoad = personalPayLoad.concat(this.hospitalDoctoreInfoPdf());
    }
    return personalPayLoad;
  }

  /**
   *
   * @returns
   */
  hospitalDoctoreInfoPdf() {
    return this.hospitalDoctorInfo('');
  }

  drInfor() {
    const personalAccidentDetailsInfo = this.captureData('doctorInfo');
    this.hsotDrInfo = personalAccidentDetailsInfo;
    return personalAccidentDetailsInfo;
  }

  /**
   *
   * @returns
   */
  getPersonalAccident() {
    const personalDetails = []
    personalDetails.push(
      {
        name: this.getData('claimBenefits', 'label', this.step2)['label'] === 'Select Claim Type' ? 'What is the nature of your claim?' : '',
        value: this.dataStoreService.get(this.step2).uiData['claimBenefits']
      });

    const arrysub1 = ['heading', 'accidentOccurred', 'injuriesSustained', 'accidentDate', 'timeIncident', 'accidentLocationLookup', 'firstVisit', 'diagnosis']
    const arraysub2 = ['heading', 'chooseClaimType'];
    arrysub1.forEach(key => {
      if (key === 'heading') {
        personalDetails.push(
          {
            name: 'Personal Accident Details',
            value: 'heading'
          });
      } else if (key === 'accidentLocationLookup') {
        if (this.getData(key, '', this.step2)) {
          personalDetails.push(
            {
              name: this.getData(key, 'label', this.step2)['label'],
              value: this.dataStoreService.checkAutoComplete(this.getData(key + 'val', '', this.step2) ? this.getData(key + 'val', '', this.step2) : this.getData(key, '', this.step2).formatted_address ? this.getData(key, '', this.step2).formatted_address : this.getData(key, '', this.step2))
            });
        }
      } else if (key === 'timeIncident') {
        personalDetails.push(
          {
            name: this.getData(key, 'label', this.step2)['label'],
            value: this.getData(key, '', this.step2)
          });

      }
      else if (key === 'diagnosis') {
        if (key.indexOf('diagnosis') > -1) {
          personalDetails.push(
            {
              name: this.getData('diagnosis', 'label', this.step2)['label'],
              value: this.getData('diagnosis', '', this.step2),
            });
        }
        if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosis']?.id === '13') {
          personalDetails.push(
            {
              name: this.getData('otherDia', 'label', this.step2)['label'],
              value: this.getData('otherDia', '', this.step2),
            });
        }
        if (this.dataStoreService.get('fnol-claimtype-details').uiData['diagnosis']?.id === '10') {
          personalDetails.push(
            {
              name: this.getData('pleaseProvideDetails', 'label', this.step2)['label'],
              value: this.getData('pleaseProvideDetails', '', this.step2),
            });
        }
      } else {
        if (this.dataStoreService.get(this.step2)?.uiData[key] !== 'diagnosis') {
          if (this.getData(key, '', this.step2)) {
            personalDetails.push(
              {
                name: this.getData(key, 'label', this.step2)['label'],
                value: this.getData(key, '', this.step2)
              }
            );
          }
        }
      }
    });
    arraysub2.forEach(key => {
      if (key === 'heading') {
        personalDetails.push(
          {
            name: 'Personal Accident Benefits',
            value: 'heading'
          });
      } else {
        const newArray = [];
        this.personalAccident = [];
        const chooseClaimType = this.dataStoreService.get('fnol-claimtype-details').uiData['chooseClaimType'];
        CHECKBOXLITEPERSONAL_GB.forEach(field => {
          chooseClaimType.forEach(element => {
            if (field.key === element.name) {
              const dataObj = Utils.getFieldFromStructure(this.uiStructure, element.name)
              const headingValue = dataObj.heading;
              newArray.push(headingValue);
              this.personalAccident.push(headingValue);
            }
          });
        });
        personalDetails.push(
          {
            name: this.getData(key, 'label', this.step2)['label'],
            value: newArray.join(', ')
          }
        );
      }
    });
    return personalDetails.filter(e => (e.name !== undefined && e.name !== null));
  }


  /**
   * Others Icon
   * @returns
   */
  getOtherDetails() {
    const otherDetailsInfo = []
    otherDetailsInfo.push({
      name: this.getData('claimBenefits', 'label', this.step2)['label'] === 'Select Claim Type' ? 'What is the nature of your claim?' : '',
      value: this.dataStoreService.get(this.step2).uiData['claimBenefits']
    });
    otherDetailsInfo.push({
      name: this.getData('claimForOther', 'label', this.step2)['label'],
      value: this.getData('claimForOther', '', this.step2)
    });
    otherDetailsInfo.push({
      name: this.getData('otherDate', 'label', this.step2)['label'],
      value: this.getData('otherDate', '', this.step2)
    });
    return otherDetailsInfo;
  }

  /**
   * This method will capture the data for Disability section.
   * @param e
   * @returns
   */
  PermanentDisablement(e?) {
    const disability = ['natureOfTheDisability', 'doctorDisability', 'nameOFEmployer', 'doctorsStreetAddressLookup', 'annualIncome', 'occupationJobTitle', 'empStartDate', 'descOfAccident', 'currentlyWorking'];
    const workDate = ['workStopDate', 'workReturnDate'];
    const duties = ['dutiesLongerPerform', 'descCurrentDuties'];
    let disabilityData = [];
    const uiData = this.dataStoreService.get(this.step2).uiData;

    disability.forEach(fieldName => {
      if (fieldName === 'doctorsStreetAddressLookup') {
        disabilityData.push(
          {
            name: this.getData(fieldName, 'label', this.step2)['label'],
            value: this.dataStoreService.checkAutoComplete(this.getData(fieldName + 'val', '', this.step2) ? this.getData(fieldName + 'val', '', this.step2) : this.getData(fieldName, '', this.step2).formatted_address ? this.getData(fieldName, '', this.step2).formatted_address : this.getData(fieldName, '', this.step2))
          }
        );
      } else if (fieldName === 'annualIncome') {
        disabilityData.push({
          'name': this.getData(fieldName, 'label', this.step2)['label'],
          'value': this.checkCustom(fieldName, '', this.step2, this.axisPipe)
        });
      } else if (fieldName === 'currentlyWorking') {
        disabilityData.push(...this.captureData('currentlyWorking'));
        if (uiData['currentlyWorking'] === 'Yes') {
          workDate.forEach(date => {
            disabilityData.push({
              'name': this.getData(date, 'label', this.step2)['label'],
              'value': this.getData(date, '', this.step2)
            });
          });
          disabilityData.push(...this.captureData('performedBeforeAccident'));
          if (uiData['performedBeforeAccident'] !== 'Yes') {
            duties.forEach(duty => {
              disabilityData.push({
                'name': this.getData(duty, 'label', this.step2)['label'],
                'value': this.getData(duty, '', this.step2)
              });
            });
          }
        } else {
          disabilityData.push(...this.captureData('returningToWork'));
          if (uiData['returningToWork'] === 'Yes') {
            workDate.forEach(date => {
              disabilityData.push({
                'name': this.getData(date, 'label', this.step2)['label'],
                'value': this.getData(date, '', this.step2)
              });
            });
          } else {
            disabilityData.push({
              'name': this.getData('workStopDate', 'label', this.step2)['label'],
              'value': this.getData('workStopDate', '', this.step2)
            });
          }
        }
      } else {
        disabilityData.push({
          name: this.getData(fieldName, 'label', this.step2)['label'],
          value: this.getData(fieldName, '', this.step2)
        });
      }
    });

    if (e && disabilityData.length > 0) {
      disabilityData = [{
        name: 'Disability',
        value: 'heading'
      }, ...disabilityData];
    }
    return disabilityData;
  }

  accidentalDeath(e?) {
    const permanentDi = ['dateOfDeath', 'causeDeath'];
    let disablityData = this.captureData(permanentDi);

    if (e && disablityData.length > 0) {
      const array = [{
        name: 'Accidental Death',
        value: 'heading'
      }];

      disablityData = [...array, ...disablityData];
    }
    return disablityData;
  }

  otherDeath(e?) {
    return this.otherDeathData('', e);
  }

  /**
   * This function will collect data of hospitalisation Section.
   * @returns
   */
  hospitalisation() {
    const personalAccidentArray = [];
    personalAccidentArray.push({
      'name': 'Hospitalisation',
      'value': 'heading'
    });
    personalAccidentArray.push(...this.hospitalisationData('addHospitalisationMain'));
    return personalAccidentArray;
  }

  /**
   *
   * This function is for newly added benefit type
   */
  fractureDislocation() {
    const array = [{
      name: 'Fracture or Dislocation',
      value: 'heading'
    }];
    const data = [...array, ...this.captureData('sustainFracture'), ...this.featureOrDisclosed(),
    ...this.captureData('sustainDislocation'), ...this.siteDisclosed()];
    return data.filter(e => (e.name !== undefined));
  }

  featureOrDisclosed() {
    const nonBagNoEMp = ['siteFracture', 'typeFracture'];
    const travelArr = this.buildDetailsWithoutNull({ mainUIFieldName: 'addFractureMain', fieldNames: nonBagNoEMp, conditionalFieldName: 'sustainFracture' });
    return travelArr.filter(e => (e.name !== undefined));
  }


  siteDisclosed() {
    const nonBagNoEMp = ['siteDislocation'];
    const travelArr = this.buildDetailsWithoutNull({ mainUIFieldName: 'addDislocationMain', fieldNames: nonBagNoEMp, conditionalFieldName: 'sustainDislocation' });
    return travelArr.filter(e => (e.name !== undefined));
  }

  /**
   * Reusable method to capture the hospitalisation details which have radio button with it.
   * @param main
   * @returns array of hospitalisation data
   */
  hospitalisationData(main) {
    const personalAccidentArray = [];
    let tempArray = [];
    const hospitalisation = Utils.getFieldFromStructure(this.dataStoreService.get(this.step2).uiStructure, main).fields;
    hospitalisation.forEach((card) => {
    card.fields.forEach((data) => {
      data?.fields?.forEach((item) => {
        tempArray.push({
          'name': this.getData(item.name, 'label', this.step2)['label'],
          'value': this.getData(item.name, '', this.step2)
        });
      });
      if (tempArray[5].value === 'No') {
        tempArray.pop();
        tempArray.pop();
      }
      personalAccidentArray.push(...tempArray);
      tempArray = [];
    });
    });
    return personalAccidentArray.filter(e => (e.name !== undefined));
  }

  /**
   * This method will reoder the countries in the alphabetic order for multiSelect dropdown travelDestination.
   * @param data
   * @returns
   */
  countryOrder(data) {
    const unordered = data.split(',')
    const field = Utils.getFieldFromStructure(this.uiStructure, 'travelDestination');
    const countryList = [];
    const travelDestination = [];
    field.options.forEach(res => countryList.push(res.name));
    countryList.forEach(orderedValue => {
      unordered.forEach(value => {
        if (orderedValue === value) {
          travelDestination.push(value);
        }
      });
    });
    return travelDestination.join(', ');
  }
}